// extracted by mini-css-extract-plugin
export default {"infosRole":"Infos_infosRole__0yf+e"};